import { Children, type ReactNode, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { QUICK_LINKS_PORTAL_ID } from './QuickLinksPortal'
function findChildWithIdGreaterThan(portal: HTMLElement, id: string): HTMLElement | null {
  const children = portal.querySelectorAll(`[id]`)
  for (const child of children) {
    if (child.id < id) continue
    return child as HTMLElement
  }
  return null
}
function getContainer(id: string): HTMLElement | null {
  const portal = document.getElementById(QUICK_LINKS_PORTAL_ID)
  if (!portal) return null
  const container = portal.querySelector(`[id="${id}"]`)
  if (container) return container as HTMLElement
  const newContainer = document.createElement('div')
  newContainer.id = id
  const child = findChildWithIdGreaterThan(portal, id)
  if (child) {
    portal.insertBefore(newContainer, child)
  } else {
    portal.appendChild(newContainer)
  }
  return newContainer as HTMLElement
}

function QuickLinks({ children, id }: { children: ReactNode; id: string }) {
  const [container, setContainer] = useState<HTMLElement | null>(getContainer(id))
  useEffect(() => {
    if (!id) return
    const interval = setInterval(() => {
      const container = getContainer(id)
      if (!container) return
      clearInterval(interval)
      setContainer(container)
    }, 100)
    return () => clearInterval(interval)
  }, [id])
  if (!id) return null
  if (!container) return null
  return createPortal(<>{children}</>, container)
}

export function Links({ children }: { children: ReactNode }) {
  const childrenArray = Children.toArray(children)

  return (
    <ul>
      {childrenArray.map((child, index) => (
        <li key={index}>{child}</li>
      ))}
    </ul>
  )
}

export default QuickLinks
